<template>
  <div class="position-sticky" style="top: 80px; z-index: 1">
    <v-btn
      v-for="(navItem, idx) in inventoryNav?.subItems"
      :key="`inventory-nav-${idx}`"
      :to="navItem.to"
      class="ma-sm-2 my-2"
      size="large"
      color="grey-darken-4"
      variant="flat"
      block
    >
      {{ navItem.label }}
    </v-btn>
  </div>
</template>

<script setup>
const storeLeftNav = useLeftNavStore()

const inventoryNav = computed(() => {
  return storeLeftNav.nav.find((n) => n.label == 'INVENTORY')
})
</script>

<style scoped>
.v-list-group__items .v-list-item {
  padding-left: 20px !important;
}
</style>
